import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../dashboard/components/Header';
import Sidebar from '../dashboard/components/Sidebar';
import OrdersList from './components/OrdersList';
import DeliveryNotesList from './components/DeliveryNotesList';
import CustomerInvoicesList from './components/CustomerInvoicesList';

export default function SalesPage() {
  const [activeTab, setActiveTab] = useState('orders');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const renderContent = () => {
    switch (activeTab) {
      case 'orders':
        return <OrdersList />;
      case 'delivery':
        return <DeliveryNotesList />;
      case 'invoices':
        return <CustomerInvoicesList />;
      default:
        return <OrdersList />;
    }
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <div className="flex-1 flex flex-col lg:ml-64">
        <Header onMenuClick={() => setIsSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto pt-24 p-6">
          <div className="max-w-7xl mx-auto">
            {/* En-tête */}
            <div className="mb-6">
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-shopping-cart-line text-3xl text-teal-600"></i>
                <h1 className="text-3xl font-bold text-gray-900">Ventes</h1>
              </div>
              <p className="text-gray-600">Gérez vos commandes, bons de livraison et factures clients</p>
            </div>

            {/* Navigation par onglets */}
            <div className="bg-white rounded-lg shadow-sm mb-6">
              <div className="border-b border-gray-200">
                <nav className="flex -mb-px">
                  <button
                    onClick={() => setActiveTab('orders')}
                    className={`px-6 py-4 text-sm font-medium border-b-2 whitespace-nowrap cursor-pointer ${
                      activeTab === 'orders'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <i className="ri-shopping-cart-line mr-2"></i>
                    Commandes Clients
                  </button>
                  <button
                    onClick={() => setActiveTab('delivery')}
                    className={`px-6 py-4 text-sm font-medium border-b-2 whitespace-nowrap cursor-pointer ${
                      activeTab === 'delivery'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <i className="ri-truck-line mr-2"></i>
                    Bons de Livraison
                  </button>
                  {/* <button
                    onClick={() => setActiveTab('invoices')}
                    className={`px-6 py-4 text-sm font-medium border-b-2 whitespace-nowrap cursor-pointer ${
                      activeTab === 'invoices'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <i className="ri-file-text-line mr-2"></i>
                    Factures
                  </button> */}
                </nav>
              </div>

              {/* Contenu des onglets */}
              <div className="p-6">
                {renderContent()}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
